import axios from 'axios';

export const currentWeather = location => axios.get(`http://api.openweathermap.org/data/2.5/weather?q=${location}&APPID=adc11990dcb685cf8bc8534db4a8c605`);
